import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import './App.css';
import NotFoundPage from "./Pages/ErrorPage/NotFoundPage";
import LoginPage from "./Pages/Auth/Login/LoginPage";
function App() {
  return (
    <div>

      <Suspense fallback="">
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/" element={<LoginPage />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default App;
